// media swiper only mobile view 

if (window.matchMedia) {
  const mq = window.matchMedia("(min-width: 990px)");
  mq.addListener(handleWidthChange);
  handleWidthChange(mq);
}

function handleWidthChange(mq) {
  const sliderEl_div = document.querySelector('[product-main-section] [data-main-pdp-swiper]');
  if (!sliderEl_div) return; // exit if no slider on this page

  const sliderEl = document.querySelector('[product-main-section] [data-pdp-main-slider]');
  if (!sliderEl) return;

  const optionsAttr = sliderEl.getAttribute('data-slider-options');

  if (mq.matches) {
    // Desktop: destroy swiper if exists
    if (sliderEl_div.swiper) {
      sliderEl_div.swiper.destroy(true, true);
    }
  } else {
    // Mobile: initialize swiper if not already initialized
    if (!sliderEl_div.swiper) {
      if (optionsAttr) {
        const options = JSON.parse(optionsAttr);
        new Swiper(sliderEl_div, options);
      }
    }
  }
}


window.addEventListener('scroll', function() {
  const checkElement = document.querySelectorAll('[data-main-pdp-swiper] .product-media-item') || null;
  checkElement.forEach(function(item) {
    // Get the element's bounding box
    const rect = item.getBoundingClientRect();
    
    const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
  
    // Add or remove the class based on visibility
    if (isVisible) {
     if (document.querySelector('.active-scroll-slide[data-media-id]')) {
        document.querySelector('.active-scroll-slide[data-media-id]').classList.remove('active-scroll-slide');
      }
      document.querySelector('[data-media-id ="'+item.getAttribute('data-media-id')+'"]').classList.add('active-scroll-slide');
    }
  });
});

const header_operlay = document.querySelector("[data-banner-header-overlay]");
if(header_operlay){
  document.body.classList.add('header-overlay');
}


// Image Hotspots
class customImageHotspots extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.getAttribute("data-tooltips");
    this.attachEventListeners = this.attachEventListeners.bind(this);
    this.updateContent = this.updateContent.bind(this);
  }

  connectedCallback() {
    this.initializeSection();
    this.reinitializeOnShopifyEvents();
  }

  updateContent(blockId, content) {
    const gridItemRight = this.querySelector(
      ".grid-item.right .dynamic-content-placeholder"
    );
    if (gridItemRight) {
      gridItemRight.style.transition =
        "opacity 0.4s ease-out, transform 0.4s ease-out";
      gridItemRight.style.opacity = "0";
      gridItemRight.style.transform = "translateY(10px)";
      setTimeout(() => {
        gridItemRight.style.opacity = "1";
        gridItemRight.style.transform = "translateY(0)";
      }, 400);
    }
  }


  attachEventListeners() {
    // image hotspot hover
    this.querySelectorAll("[data-tooltip-trigger]").forEach((button) => {
      const allButtons = this.querySelectorAll("[data-tooltip-trigger]");
      const allTooltips = this.querySelectorAll("[data-tooltip-overlay]");

      const blockId = button.value;
      const tooltipdiv = this.querySelector(
        `[data-tooltip-overlay]#tooltip-overlay-main-${blockId}`
      );

      if (!tooltipdiv) return;

      button.addEventListener("mouseenter", () => {

        // 🔄 RESET ALL FIRST
        allButtons.forEach((btn) => {
          btn.setAttribute("aria-expanded", "false");
          btn.classList.remove("active_tool");
        });

        allTooltips.forEach((tip) => {
          tip.classList.remove("tooltip-active");
          tip.style.opacity = "0.3";
          tip.style.removeProperty("background-color");
        });

        // ✅ APPLY CURRENT ACTIVE
        button.setAttribute("aria-expanded", "true");
        button.classList.add("active_tool");

        tooltipdiv.classList.add("tooltip-active");
        tooltipdiv.style.opacity = "1";

        const bgColor = button.getAttribute("data-colorBG");
        if (bgColor) {
          tooltipdiv.style.backgroundColor = bgColor;
          tooltipdiv.style.setProperty("--after-bg", bgColor);
        }
      });
    });

    // product card hover
    this.querySelectorAll("[custom-data-tooltip-trigger]").forEach((button) => {
      const allButtons = this.querySelectorAll("[custom-data-tooltip-trigger]");
      const allTooltips = this.querySelectorAll("[data-tooltip-trigger]");

      const blockId = button.getAttribute("block-id");

      const tooltipdiv = this.querySelector(
        `[data-tooltip-trigger][value="${blockId}"]`
      );

      if (!tooltipdiv) return;

      button.addEventListener("mouseenter", () => {

        // 🔄 RESET ALL
        allButtons.forEach((btn) => {
          btn.style.opacity = "1";
          btn.classList.remove("tooltip-active");
          btn.style.removeProperty("background-color");
        });

        allTooltips.forEach((tip) => {
          tip.setAttribute("aria-expanded", "false");
          tip.classList.remove("active_tool");
        });

        // ✅ APPLY CURRENT
        allButtons.forEach((btn) => {
          btn.style.opacity = "0.3";
        });
        button.style.opacity = "1";

        tooltipdiv.setAttribute("aria-expanded", "true");
        tooltipdiv.classList.add("active_tool");

        button.classList.add("tooltip-active");

        const bgColor = tooltipdiv.getAttribute("data-colorBG");
        if (bgColor) {
          button.style.backgroundColor = bgColor;
          button.style.setProperty("--after-bg", bgColor);
        }
      });
    });


    // div mouselaeve
    const container = this.querySelector(".image-hotspots");
    const buttons = this.querySelectorAll("[custom-data-tooltip-trigger]");
    const tooltips = this.querySelectorAll("[data-tooltip-trigger]");

    if (container) {
      container.addEventListener("mouseleave", () => {

        // 🔄 RESET BUTTONS
        buttons.forEach((btn) => {
          btn.style.opacity = "1";
          btn.classList.remove("tooltip-active");
          btn.style.removeProperty("background-color");
        });

        // 🔄 RESET TOOLTIPS
        tooltips.forEach((tip) => {
          tip.style.opacity = "1";
          tip.setAttribute("aria-expanded", "false");
          tip.classList.remove("active_tool");
          tip.style.removeProperty("background-color");
        });

      });
    }


  }

  initializeSection() {
    this.attachEventListeners();
  }

  reinitializeOnShopifyEvents() {
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener("shopify:section:load", (event) => {
        if (event.detail.sectionId === this.sectionId) {
          this.initializeSection();
        }
      });

      document.addEventListener("shopify:section:select", (event) => {
        if (event.detail.sectionId === this.sectionId) {
          this.initializeSection();
        }
      });

      document.addEventListener("shopify:section:reorder", (event) => {
        if (event.detail.sectionId === this.sectionId) {
          this.initializeSection();
        }
      });
    }
  }
}

// Define the custom element
customElements.define("custom-image-hotspots", customImageHotspots);

// Initialize all existing sections on page load
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("custom-image-hotspots").forEach((section) => {
    section.initializeSection();
  });
});



var dta = document.querySelectorAll('[discount_popup]');
dta.forEach(b => {
    // Add click event to show the popup
    b.addEventListener("click", (event) => {
        // Show the popup
        var maiN_to = document.querySelector('.popup_data');
        maiN_to.style.display = 'flex';

        // Add a class to the body
        document.body.classList.add('popup-active');
    });
    // Close button inside the popup
    var closeBtn = document.querySelectorAll('[disc_close]');
    if (closeBtn) {
      closeBtn.forEach(btn => {
        btn.addEventListener("click", (event) => {
          // Prevent the click from bubbling up to the parent elements
          event.stopPropagation();

          // Hide the popup
          var maiN_to = document.querySelector('.popup_data');
          maiN_to.style.display = 'none';

          // Remove the class from the body
          document.body.classList.remove('popup-active');
        });        
      });
    }
});



// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
        intro.onclick = (e) => {
          if (content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            accordions.forEach((accordion) => closeAccordion(accordion));
            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
    }
  });   
}
// accordions js end
(function() {
  faq_taggol();
})();


// autosize
function autosize() {
    const textareas = document.querySelectorAll('.autosize');

    textareas.forEach(textarea => {
        textarea.setAttribute('rows', 6);
        resize(textarea);

        textarea.addEventListener('input', () => resize(textarea));
    });

    function resize(textarea) {
        textarea.style.height = 'auto';
        textarea.style.height = textarea.scrollHeight + 'px';
    }
}

autosize();

function smoothScroll(target) {
  const header = document.querySelector('.shopify-section-group-header-group');
  const header_height = header ? header.offsetHeight + 100 : 150;

  const element = typeof target === "string" ? document.querySelector(target) : target;
  if (!element) return;

  const targetPosition = element.getBoundingClientRect().top + window.pageYOffset;

  window.scrollTo({
    top: targetPosition - header_height,
    behavior: "smooth"
  });
}

const mob_tabs = document.querySelectorAll('[main-mob_tabs]');

mob_tabs.forEach(tab => {
  tab.addEventListener('click', function () {
    const wrapper = this.closest('[main_wrpper]');
    wrapper.classList.toggle('open_tab');
  });
});

//faq scroll logic 
// const tabs = document.querySelectorAll('[faq_tab_btn] a');
// tabs.forEach(tab => {
//   tab.addEventListener('click', function(e) {
//     e.preventDefault();
//     const selectedHandle = this.getAttribute('data-hendles');
//     tabs.forEach((toggle) => {
//       toggle.classList.remove('active');
//     });
//     this.classList.add('active');

//     const targetAccordion = document.querySelector(`[main_tab_name][data-title="${selectedHandle.slice(1)}"]`);
//      smoothScroll(selectedHandle);
//   });
// });

const tabs = document.querySelectorAll('[faq_tab_btn] a');
const sections = document.querySelectorAll('[main_tab_name]');

// CLICK EVENT (your existing logic improved)
tabs.forEach(tab => {
  tab.addEventListener('click', function(e) {
    e.preventDefault();

    const selectedHandle = this.getAttribute('data-hendles');

    tabs.forEach(t => t.classList.remove('active'));
    this.classList.add('active');

    const div = document.querySelector('.mob_btn');
    // Find label where you want to show selected value
    const label = div.querySelector('span');

    const selectedText = this.textContent.trim();

    if (label) {
      label.textContent = selectedText;
    }

    smoothScroll(selectedHandle);
  
    const wrapper = document.querySelector('[main_wrpper]');
    wrapper.classList.remove('open_tab');

  });
});


// SCROLL EVENT (this is what you need)
window.addEventListener('scroll', () => {
  let currentSection = null;

  sections.forEach(section => {
    const rect = section.getBoundingClientRect();

    // section visible in viewport
    if (rect.top <= 150 && rect.bottom >= 150) {
      currentSection = section.getAttribute('data-title');
    }
  });

  if (currentSection) {
    tabs.forEach(tab => {
      tab.classList.remove('active');

      const handle = tab.getAttribute('data-hendles');

      // match with section
      if (handle && handle.replace('#', '') === currentSection) {
        tab.classList.add('active');
      }
    });
  }
});

//faq toggle logic 


// =============== promo  copy code js =========== //
document.querySelectorAll(".copy-code-right").forEach(function (copyBtn) {
  copyBtn.addEventListener("click", function () {
    let codeElement = this.closest(".coupan-right-block").querySelector(".copy-code-left");
    if (codeElement) {
      let codeText = codeElement.innerText.trim();
      navigator.clipboard.writeText(codeText).then(() => {
        let originalText = copyBtn.innerHTML; 
        copyBtn.innerHTML = "&#10003;";

        setTimeout(() => {
          copyBtn.innerHTML = originalText;
        }, 2000);
      }).catch(err => {
        console.error("Copy failed", err);
      });
    }
  });
});

document.querySelectorAll(".discount-bar-close-icon").forEach(function (closeBtn) {
  closeBtn.addEventListener("click", function () {
    let bar = this.closest(".coupan-code");
    if (bar) {
      bar.style.display = "none";
    }
  });
});
// =============== promo  copy code js =========== //

const items = document.querySelectorAll(".plan-item");

  function updateTooltip(el) {
    document.getElementById("tooltip-title").innerText = el.dataset.title;
    document.getElementById("tooltip-meta").innerText = el.dataset.meta;
    document.getElementById("tooltip-price").innerText = el.dataset.price;
  }

  items.forEach(item => {
    if(item.classList.contains("active")) {
      updateTooltip(item);
    }

    item.addEventListener("click", function() {
      items.forEach(i => i.classList.remove("active"));
      this.classList.add("active");
      updateTooltip(this);
    });
  });

// //app popup code 
// document.addEventListener('DOMContentLoaded', function () {
//   const bidButton = document.querySelector('.motorsport-history__button');
//   bidButton?.addEventListener('click', function (e) {
//     e.preventDefault();
//     const popup = document.querySelector('.tpa-product-widget-wrapper');
//     if (popup) {
//       popup.style.display = 'flex';
//       document.body.classList.add('popup-open');
//     }
//   });

//   document.addEventListener('click', function (e) {
//     const popup = document.querySelector('.tpa-product-widget-wrapper');
//     if (!popup || popup.style.display === 'none') return;
//     const clickedPopup = popup.contains(e.target);
//     const clickedButton = e.target.closest('.motorsport-history__button');
//     if (!clickedPopup && !clickedButton) {
//       popup.style.display = 'none';
//       document.body.classList.remove('popup-open');
//     }
//   });
// });

//scroll the section and open popup
document.addEventListener('DOMContentLoaded', function () {
  const historyButtonist = document.querySelectorAll('.one-race-banner__button');
  if(historyButtonist.length > 0){
historyButtonist.forEach((historyButton) => {

  historyButton?.addEventListener('click', function (e) {
    e.preventDefault();
    const targetSection = document.querySelector('.bid-plugin-right');
    if (targetSection) {
      targetSection.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  });

      
      });
  }
});


  const heroButton = document.querySelector('.tortour-hero__button');
  const promoSection = document.querySelector('.tottour-promo');

  if (heroButton && promoSection) {
    heroButton.addEventListener('click', function (e) {
      e.preventDefault();

      promoSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  }





function updateSubscriptionQty() {
  const isSubscribe = document.querySelector(".ks-card-wrapper.selected");
  const qtyInput = document.querySelector(".custom_qty .quantity-input");
console.log(isSubscribe,"isSubscribe",qtyInput);
  if (!qtyInput) return;

  if (isSubscribe) {
    qtyInput.value = 3;

    qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
    qtyInput.dispatchEvent(new Event("change", { bubbles: true }));

    console.log("Subscribe => Qty 3");
  } else {
    qtyInput.value = 1;

    qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
    qtyInput.dispatchEvent(new Event("change", { bubbles: true }));

    console.log("One Time => Qty 1");
  }
}

window.addEventListener("load", () => {
  setTimeout(updateSubscriptionQty, 300);
});

document.addEventListener("click", (e) => {
  if (
    e.target.closest(".kaching-subscriptions__card-wrapper") ||
    e.target.closest(".ks-card-wrapper")
  ) {
    setTimeout(updateSubscriptionQty, 100);
  }
});